function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCompressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 35,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00356B",
    d: "M123.024 14.707q-.813.032-1.267.204t-.704.736q-.249.562-.249 1.782v8.598q0 6.63 5.253 6.631 2.47 0 3.83-1.69 1.361-1.688 1.362-5.003v-8.192q0-2.096.125-2.816l-2.376.095v-2.408h7.254v2.063q-.845.033-1.283.204-.437.172-.687.736-.25.562-.25 1.782v7.816q0 5.13-2.362 7.46-2.36 2.33-6.395 2.33-4.91 0-6.957-2.612-2.048-2.612-2.048-7.082v-7.568q0-1.752.125-2.816l-2.346.095v-2.408h8.975zM87.376 18.71h-2.064q0-2.314-1.111-3.204t-2.672-.83l-1.126.031q-.753.032-1.19.204-.438.172-.672.766t-.234 1.752v4.69h3.66q-.033-.53-.126-2.72h2.408v7.598h-2.064q0-1.25-.39-1.845-.392-.593-1.018-.764-.626-.173-1.657-.143l-.813.032v5.127q0 1.69-.125 2.753h4.19q1.595 0 2.706-1.078 1.11-1.08 1.11-3.425h2.031l-.155 6.88h-16.51V32.47q.842-.032 1.28-.203.439-.173.688-.735.25-.564.25-1.784V17.773q0-1.752.126-2.816l-2.345.095v-2.408H87.19zm12.791-6.097q3.907 0 6.613 1.55 2.705 1.545 4.034 4.018 1.328 2.469 1.328 5.19 0 2.75-1.266 5.299t-4.003 4.206q-2.736 1.657-6.864 1.657h-8.942V32.47q.843-.032 1.281-.203.437-.173.687-.735.25-.564.25-1.784V17.773q0-1.752.126-2.816l-2.344.095v-2.408zm-.377 2.094q-1.062 0-1.516.533-.454.532-.453 2.126v12.038q0 1.752-.126 2.816a3.6 3.6 0 0 1 .595-.032l1.345.032q.406.03 1.031.03 2.188 0 3.658-1.156 1.47-1.158 2.174-3.018t.704-4.05q0-4.752-1.939-7.036-1.938-2.283-5.473-2.283",
    style: {
      fill: "#00356b",
      fill: "color(display-p3 0 .2078 .4196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 16,
    height: 11,
    x: 129,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.458 4.767h15.167v9.316h-15.167z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 28,
    height: 24,
    x: 123,
    y: -4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m128.587-3.798 22.406 8.043-5.572 15.524-22.407-8.043z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 28,
    height: 24,
    x: 123,
    y: -4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m128.587-3.798 22.406 8.043-5.572 15.524-22.407-8.043z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C78D8",
    d: "M136.727 9.445a1.4 1.4 0 0 1-.394-.216l-5.63-4.43c-.224.26-.422.628-.625 1.194.331.392.563 1.024.262 1.86-.184.514-.573.79-.882.957.554 1.441 2.881 3.17 5.963 4.276 3.882 1.394 7.479 1.267 8.035-.28l1.115-3.108-7.405-.17a1.4 1.4 0 0 1-.439-.083",
    style: {
      fill: "#3c78d8",
      fill: "color(display-p3 .2353 .4706 .8471)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 27,
    height: 13,
    x: 123,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M123.392 0h26.216v12.35h-26.216z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 28,
    height: 24,
    x: 123,
    y: -4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m128.587-3.798 22.407 8.043-5.573 15.524-22.406-8.043z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 28,
    height: 24,
    x: 123,
    y: -4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m128.587-3.798 22.407 8.043-5.573 15.524-22.406-8.043z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C78D8",
    d: "M149.395 7.746 140.114.447a.47.47 0 0 0-.278-.1l-11.805-.27a.467.467 0 0 0-.299.833l2.128 1.673c-.788.446-1.437 1.24-2.087 2.676-.447.043-.855.33-1.017.782-.165.46-.029.949.301 1.267-1.417 2.869-3.567 3.222-3.658 3.478-.047.13 1.072 1.377 1.401 1.495.51.183 2.043-.242 2.713-2.11.395-1.1.594-1.966.701-2.594.356-.103.665-.35.8-.726.148-.41.042-.835-.215-1.15 1.061-2.375 1.963-2.513 4.06-2.615.209-.007.604-.022.834-.033.411-.02.783-.034 1.138-.048 1.148-.038 2.112-.054 2.845-.06.799.002 1.151.024 1.163.024a.56.56 0 0 1-.024 1.12c-.023 0-1.384-.09-5.069.084q-.355.016-.675.024c-.435.014-.793.021-1.101.047l5.043 3.966a.5.5 0 0 0 .278.1l11.805.27a.467.467 0 0 0 .299-.834",
    style: {
      fill: "#3c78d8",
      fill: "color(display-p3 .2353 .4706 .8471)",
      fillOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#3C78D8",
    d: "M26.804 18.397q2.25 0 4.033.97t2.815 2.8q1.032 1.827 1.033 4.267-.001 2.596-.986 4.534-.985 1.94-2.752 3.003t-4.049 1.064q-2.284 0-4.098-.97a7.04 7.04 0 0 1-2.845-2.783q-1.03-1.815-1.031-4.222 0-2.534 1.063-4.503t2.86-3.065a7.46 7.46 0 0 1 3.957-1.095m15.853 9.757q0 2.066.533 3.035.531.969 1.689.968.782 0 1.61-.437a5 5 0 0 0 1.39-1.064v-6.13q0-1.47.126-2.72l-2.189.095v-2.379q1.971 0 3.174-.28 1.204-.281 1.612-.657h1.72V29.5q0 1.5-.126 2.75a22 22 0 0 1 2.032-.093v2.377h-5.942l-.186-1.627h-.033q-1.155 1.002-2.236 1.565-1.078.563-2.422.563-2.785 0-3.988-1.627t-1.203-5.284v-3.598q0-1.313.092-2.72l-2.188.095v-2.379q1.97 0 3.19-.28 1.22-.281 1.626-.657h1.72zM9.237 14.688q-1.002-.062-1.613.251-.61.312-.61.97 0 .564.377 1.19l2.378 3.913q.094.156.704 1.221t.893 1.816h.032q.094-.22.217-.486.126-.265.283-.61.783-1.564.97-1.973l1.628-3.192q.972-2.067 1.66-2.849v-.032L14.527 15l-.783.032v-2.41h6.92v2.066a3.37 3.37 0 0 0-1.879.893q-.782.735-1.691 2.458l-4.07 7.827v3.537q0 1.753-.125 2.817a29 29 0 0 1 2.505-.093v2.41H6.263V32.47q.843-.03 1.283-.203.438-.172.69-.736.25-.564.25-1.784v-2.724l-5.76-9.11a13 13 0 0 1-.831-1.628q-.36-.846-.36-1.346L0 15.032v-2.41h9.237zm57.842 3.71q1.188 0 1.955.655.767.657.767 1.94 0 .813-.532 1.502-.532.687-1.596.687-.78 0-1.39-.406-.61-.405-.704-1.408-.877 0-1.799 1.017-.923 1.016-1.234 2.016V29.5q0 1.5-.125 2.75a22 22 0 0 1 2.033-.093v2.377H56.26V32.5q1.188 0 1.516-.658.328-.656.328-2.126v-5.253q0-1.407.126-2.658l-2.189.095v-2.379q1.97 0 3.19-.28 1.22-.281 1.625-.657h1.533q.062.469.092 1.22.033.75.033 1.469h.062q2.126-2.877 4.503-2.877m-40.275 2.19q-1.72 0-2.502 1.625t-.782 4.002q0 2.72.844 4.66.845 1.94 2.597 1.94 1.72-.002 2.407-1.596t.687-4.004q0-2.688-.782-4.658-.78-1.97-2.47-1.97",
    style: {
      fill: "#3c78d8",
      fill: "color(display-p3 .2353 .4706 .8471)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h150v35H0z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCompressed);
export default __webpack_public_path__ + "static/media/logo-compressed.46691c9f8313fdbeef0a9e62199b3b10.svg";
export { ForwardRef as ReactComponent };